var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-popover", {
    ref: "popover",
    attrs: {
      placement: "top-start",
      trigger: "hover",
      disabled: _vm.disabled
    },
    on: {
      show: _vm.reset
    }
  }, [_c("el-table", {
    style: {
      width: _vm.tableWidth + "px"
    },
    attrs: {
      data: _vm.list
    },
    on: {
      "hook:mounted": _vm.reset,
      "hook:updated": _vm.reset
    }
  }, [!_vm.type || _vm.type === "address" ? [_c("el-table-column", {
    attrs: {
      prop: "address",
      label: "地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _ref$row = _ref.row,
          address = _ref$row.address,
          city_name = _ref$row.city_name,
          district_name = _ref$row.district_name;
        return [_vm._v(" " + _vm._s((city_name || "") + ("-" + district_name || "") + "-" + (address || "")) + " ")];
      }
    }], null, false, 758737706)
  }), _c("el-table-column", {
    attrs: {
      prop: "rent",
      label: "租金",
      width: "100"
    }
  })] : _vm._e(), _vm.type === "rentType" ? [_c("el-table-column", {
    attrs: {
      prop: "rent_type",
      label: "类型",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var rent_type = _ref2.row.rent_type;
        return [_vm._v(" " + _vm._s(_vm.rentTypeName(rent_type)) + " ")];
      }
    }], null, false, 3886772052)
  })] : _vm._e(), _vm.type === "bedroom" || _vm.type === "bathroom" ? [_c("el-table-column", {
    attrs: {
      prop: "bedroom",
      label: "卧室",
      width: "70"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "bathroom",
      label: "洗手间",
      width: "70"
    }
  })] : _vm._e(), _c("el-table-column", {
    attrs: {
      prop: "created_at",
      label: "时间",
      width: "170"
    }
  })], 2), _c("div", {
    class: _vm.color,
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_vm._t("default")], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };